import { render, staticRenderFns } from "./CFormItem.vue?vue&type=template&id=28a6b68c"
import script from "./CFormItem.vue?vue&type=script&lang=js"
export * from "./CFormItem.vue?vue&type=script&lang=js"
import style0 from "./CFormItem.vue?vue&type=style&index=0&id=28a6b68c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports